import { Rol, RolForm, RolUpsert } from '@models/.';
import { transformArrayRoleModuleForm, transformArrayRoleModuleUpsert } from '..';

export function transformToData(role: Rol | null): Rol | null {
  if (!role) return null;
  
  return {
    ...role,
  };
}

export function transformToForm(role?: Rol): RolForm | undefined {
  if (!role) return;
  
  const {
    id,
    nombre: name,
    resellerId,
    modules,
  } = role;
  
  return {
    id,
    name,
    resellerId,
    modules: transformArrayRoleModuleForm(modules),
  };
}

export function transformToUpsert(roleForm: RolForm): RolUpsert | undefined {
  if (!roleForm) return;
  
  const {
    name,
    modules,
  } = roleForm
  
  return {
    nombre: name,
    modules: transformArrayRoleModuleUpsert(modules),
  };
}